var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-wrapper"},[_c('el-pagination',{attrs:{"layout":_vm.layout,"total":_vm.total,"page-size":_vm.pageSize,"hide-on-single-page":_vm.hideOnSinglePage},on:{"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }